import "./theme-default.a8db3107.css";
import $lIJZP$vars_spectrumdarkest_cssmodulejs from "./vars_spectrum-darkest_css.module.js";
import "./theme-default.6c535ac4.css";
import $lIJZP$vars_spectrumglobal_cssmodulejs from "./vars_spectrum-global_css.module.js";
import "./theme-default.93dd58f2.css";
import $lIJZP$vars_spectrumlarge_cssmodulejs from "./vars_spectrum-large_css.module.js";
import "./theme-default.d52e4ea9.css";
import $lIJZP$vars_spectrumlight_cssmodulejs from "./vars_spectrum-light_css.module.js";
import "./theme-default.af816b25.css";
import $lIJZP$vars_spectrummedium_cssmodulejs from "./vars_spectrum-medium_css.module.js";


function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ /// <reference types="css-module-types" />





let $bf24a13e98395dd3$export$bca14c5b3b88a9c9 = {
    global: ($parcel$interopDefault($lIJZP$vars_spectrumglobal_cssmodulejs)),
    light: ($parcel$interopDefault($lIJZP$vars_spectrumlight_cssmodulejs)),
    dark: (0, ($parcel$interopDefault($lIJZP$vars_spectrumdarkest_cssmodulejs))),
    medium: ($parcel$interopDefault($lIJZP$vars_spectrummedium_cssmodulejs)),
    large: ($parcel$interopDefault($lIJZP$vars_spectrumlarge_cssmodulejs))
};


export {$bf24a13e98395dd3$export$bca14c5b3b88a9c9 as theme};
//# sourceMappingURL=module.js.map
